const $infoBox = $('#content-section .front-page-info-box');

$infoBox.find('.close-btn').click(function() {
    $infoBox.addClass('hide');
});